export default function initScripts() {
const cookieBanner = document.querySelector(".alert-bar");
if (cookieBanner) {
  const cookieBannerMessage = document.querySelector(
    ".alert-bar .text-holder"
  )?.innerText;

  const currentCookieMessage = localStorage.getItem("cookieMessage");

  if (!currentCookieMessage) {
    cookieBanner.style.display = "block";
  } else if (currentCookieMessage != cookieBannerMessage) {
    cookieBanner.style.display = "block";
    localStorage.removeItem("cookieMessage");
  }

  document.querySelector(".alert-bar .close").addEventListener("click", () => {
    cookieBanner.style.display = "none";
    localStorage.setItem("cookieMessage", cookieBannerMessage);
  });
}

if (document.querySelector(".wpcf7")) {
  document.querySelector(".wpcf7").addEventListener("wpcf7mailsent", (e) => {
    window.location.href = "/thank-you";
  });
}

if ($(".card-section") && $(".filter-bar")) {
  $(".clear-hold").on("click", function () {
    $(".card-section .card-item > div").show();
    // Hide all headers when filters are cleared
    $(".card-section .head-area h2, .card-section .head-area p").hide();
  });

  $(".filter-bar.keystage .dropdown-item").on("click", function () {
    const keyStages = $(".filter-bar.keystage .dropdown-item > input:checked")
      .map(function () {
        return this.id;
      })
      .get();
    
    let hasVisibleItems = false;
    
    if (keyStages.length == 0) {
      $(".card-section .card-item > div").show();
      $(".card-section .no-results").hide();
      return;
    }
    
    $(".card-section .card-item > div").each(function () {
      if (keyStages.includes(this.dataset.keyStage)) {
        $(this).show();
        hasVisibleItems = true;
      } else {
        $(this).hide();
      }
    });
    
    if (hasVisibleItems) {
      $(".card-section .no-results").hide();
    } else {
      $(".card-section .no-results").show();
    }
  });

  // Hide all headers initially for trustees section
  $(".card-section.has-trustee-filter .head-area h2, .card-section.has-trustee-filter .head-area p").hide();

  $(".filter-bar.trustees .dropdown-item").on("click", function () {
    $(".filter-bar.trustees .dropdown-item").removeClass("active");
    $(this).toggleClass("active");
    const trustee_type = $(this).data("trustee");

    $(".card-section .card-item > div").each(function () {
      if (trustee_type == this.dataset.trustee) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    $(".card-section .head-area h2").each(function () {
      if (trustee_type == this.dataset.trustee) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });

    $(".card-section .head-area p").each(function () {
      if (trustee_type == this.dataset.trustee) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
}

function formatDate(timestamp) {
  return new Date(timestamp)
    .toISOString()
    .slice(0, 10)
    .split("-")
    .join("");
}

if (document.querySelector(".filter-bar.events")) {
  
  
  loadPosts("all", 1, "all");

  const clearFiltersButton = $(".filter-bar .clear-hold");

  $(".modal-footer button").on("click", function () {
    $(".modal-header .btn-close").click();
  });

  clearFiltersButton.on("click", function () {
    $('input[name="filter-type"]').prop("checked", false);
    
    // Clear vanilla datepicker if available
    const datepickerElement = document.getElementById('datepicker');
    if (datepickerElement && datepickerElement._datepicker) {
      datepickerElement._datepicker.setDate();
      datepickerElement.classList.remove('user-selected');
    }
    
    clearFiltersButton.hide();
    loadPosts("all", 1, "all");
  });

  // Handle checkbox clicks directly
  $(document).on(
    "click",
    ".filter-bar.events input[name='filter-type']",
    function () {
      setTimeout(() => {
        processFilterChange();
      }, 10);
    }
  );
  
  // Handle dropdown item clicks (to toggle checkboxes)
  $(document).on(
    "click",
    ".filter-bar.events .dropdown-item",
    function (e) {
      const checkbox = $(this).find('input[name="filter-type"]');
      
      if (checkbox.length > 0) {
        // If click was on the checkbox itself, let it handle naturally
        if (e.target.type === 'checkbox' || $(e.target).is('input[type="checkbox"]')) {
          setTimeout(() => {
            processFilterChange();
          }, 10);
          return;
        }
        
        // If click was on label, let it handle naturally
        if (e.target.tagName === 'LABEL' || $(e.target).is('label')) {
          setTimeout(() => {
            processFilterChange();
          }, 10);
          return;
        }
        
        // Otherwise, toggle the checkbox programmatically
        e.preventDefault();
        checkbox.prop('checked', !checkbox.prop('checked'));
        
        setTimeout(() => {
          processFilterChange();
        }, 10);
      }
    }
  );
  
  // Handle modal footer button clicks (date selection)
  $(document).on(
    "click",
    ".modal-footer button",
    function () {
      // Mark the datepicker as having been used by the user
      const datepickerElement = document.getElementById('datepicker');
      if (datepickerElement) {
        datepickerElement.classList.add('user-selected');
      }
      
      processFilterChange();
    }
  );
  
  function processFilterChange() {
    const types = [];
    const checkedInputs = $('input[name="filter-type"]:checked');
    
    checkedInputs.each(function () {
      const typeValue = $(this).data("type");
      if (typeValue) {
        types.push(typeValue);
      }
    });
    
    // Get selected date from vanilla datepicker if available
    // Only use the date if the user has explicitly selected it
    const datepickerElement = document.getElementById('datepicker');
    let selectedDate = null;
    let userHasSelectedDate = false;
    
    if (datepickerElement && datepickerElement._datepicker) {
      const pickerDate = datepickerElement._datepicker.getDate();
      
      // Check if the datepicker has been interacted with by the user
      const datepickerInput = datepickerElement.querySelector('input');
      const hasUserInteraction = datepickerElement.classList.contains('user-selected') || 
                                (datepickerInput && datepickerInput.value && datepickerInput.value.trim() !== '');
      
      if (hasUserInteraction && pickerDate) {
        selectedDate = pickerDate;
        userHasSelectedDate = true;
      }
    }

    // Show clear button if there are active filters (types or user-selected date)
    if (types.length > 0 || userHasSelectedDate) {
      clearFiltersButton.show();
    } else {
      clearFiltersButton.hide();
    }

    const finalTypes = types.length > 0 ? types : "all";
    const finalDate = userHasSelectedDate && selectedDate ? formatDate(selectedDate.getTime()) : "all";
    
    loadPosts(finalTypes, 1, finalDate);
  }

  $(document).on("click", "#whatson-pagination a", function (e) {
    e.preventDefault();
    const url = $(this).attr("href");
    const urlParams = new URLSearchParams(url);
    const type = urlParams.get("type");
    const page = urlParams.get("paged");
    const date = urlParams.get("date");

    const types = type
      ? type
          .slice(1, -1)
          .split(",")
          .map((item) => item.trim())
      : "all";

    loadPosts(types, page, date ?? null);
  });

  function loadPosts(type, page, date) {
    // Ensure consistent data format - always send as JSON string if it's an array
    let typeParam = type;
    if (Array.isArray(type) && type.length > 0) {
      typeParam = JSON.stringify(type);
    } else if (type === "all" || (Array.isArray(type) && type.length === 0)) {
      typeParam = "all";
    }
    
    const ajaxData = {
      action: "filter_events",
      type: typeParam,
      page: page,
      date: date,
    };
    
    $.ajax({
      type: "POST",
      url: ajax.url,
      data: ajaxData,
      beforeSend: function () {
        $("#ajax-posts-container").html("<p>Loading...</p>");
      },
      success: function (response) {
        $("#ajax-posts-container").html(response.posts);
        const pagination = $("#whatson-pagination");
        if (!response.pagination && pagination.html()) {
          return pagination.html("");
        }
        pagination.html(response.pagination);
      },
      error: function (xhr, textStatus, error) {
        $("#ajax-posts-container").html("<p>Error loading posts.</p>");
      },
    });
  }
}
}
